import { pipe, toUpper, trim, slice, replace, sortBy, concat, split,reduce, values,startsWith,find,__,filter, prop } from 'ramda';


const deburr = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

export const simplifyValueArray = pipe(
  trim,
  toUpper,
  deburr,
  split(" "),
  filter(text => (text.length))
);

export const simplifyValue = pipe(
  trim,
  toUpper,
  deburr
);

export const simplifyValueWithSpace = pipe(
  toUpper,
  deburr
);

export const parseRestriccions = (type) => {
  switch (type) {
    case "release":
      return "_%restricción : Anticipación mínima {value} días%_";
    case "min_days":
      return "_%restricción : Estancia mínima {value} noches%_";
    case "max_days":
      return "_%restricción : Estancia màxima {value} noches%_";
    case "allow_checkin":
      return "_%restricción : No se permitir entrada%_";
    case "allow_checkout":
      return "_%restricción : No se permite salida permitir salida%_";
    default:
  }
};

/*listInputValue.forEach((value) => {

  const idx = matchStrong.indexOf(value);
  const newMatchetStrongValue = slice(idx, idx + value.length)(matchStrong);

  matchStrong = replace(newMatchetStrongValue, '<strong>' + newMatchetStrongValue + '</strong>', matchStrong);

  const newMatchetValue = slice(idx, idx + value.length)(result);

  result = replace(newMatchetValue, '<strong>' + newMatchetValue + '</strong>', result);

});
*/

export const replaceSearchValue = (inputValue, match) => {
  if (match && inputValue) {
    let simpleValue = simplifyValue(inputValue);
    let result = "";
    let listInputValue = pipe(simplifyValueArray,filter((elem)=>(elem.length>=1)), sortBy((word)=>word.length))(simpleValue);
    let  currentRange, findInputValue;
    var letter = 0;
    //var positionName = 0;


    while (letter < match.simpleText.length) {
      currentRange = slice(letter, Infinity, match.simpleText);
      findInputValue = find(startsWith(__,currentRange), listInputValue)

      if(findInputValue) {
        const concatVal = slice(letter, letter+findInputValue.length, match.name)
        result+= '<strong>' + concatVal + '</strong>';
        letter += findInputValue.length;
      }else {
        result+= slice(letter, letter+1, match.name);
        letter++;
      }
    }
    return result;
  } else if(match) {
    return match.name;
  }
  return '';
};


export const replaceInputSearchValue = (inputValue, match) => {

  if (match && inputValue) {
    const idx = match.simpleText.indexOf(simplifyValue(inputValue));
    const newMatchetValue = slice(idx, idx + inputValue.length)(match.name);

    return replace(newMatchetValue, '<strong >' + inputValue + '</strong>', match.name);
  }

  return '';
};

var initiate = (data, type) => {
return reduce((acc, entity)=> {
  let newEntity = acc[entity.id] = {...entity, type};

  if(type === "country") {
    newEntity.cities = []
  }
  if(type !== "hotel"){
    newEntity.hotels = [];
  }

  return acc;
},{}, data);
}



export const parseHotelsInfo = (hotelsInfo) => {
  if(!hotelsInfo) {
    return null;
  }
  let mapCountries = initiate(hotelsInfo.countries, "country");
  let mapCities = initiate( hotelsInfo.cities, "city");
  let mapHotels = initiate( hotelsInfo.hotels, "hotel");

  const parseSearchEntities = pipe(
    (list)=>reduce(concat, [],list),
    (list) => reduce((result, entity) => {
      //is city
      if(entity.type === "city") {
        mapCountries[entity.country_id].cities[entity.id] = entity;
      }

      //is hotel
      if(!entity.type || entity.type === "hotel") {
        mapCities[entity.city_id].hotels.push(entity);
        mapCountries[entity.country_id].hotels.push(entity);
      }

      entity.name = entity.stars ? entity.name + ' ' + entity.stars : ""+entity.name;
      entity.simple = entity.name && simplifyValueArray(entity.name);

      const existWord = find((fullWord) => {
        return fullWord && fullWord.includes("-");
      }, entity.simple);

      if (existWord) {
        entity.simple.push(existWord.replace("-", ""));
      }

      entity.simpleText = simplifyValue(entity.name);
      result.push(entity);
      return result;
    },[],list),
    sortBy(prop("simpleText")),
  );

  return {
    hotels : parseSearchEntities([hotelsInfo.hotels]),
    destinations : parseSearchEntities([values(mapCountries), values(mapCities)]),
    mapCountries,
    mapCities,
    mapHotels
  };




}

